import React from 'react'
import {useTranslation} from 'react-i18next'
import {ErrorsType} from 'reactjs-use-form'

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import {
  Box,
  Grid,
  Stack,
  TextField,
  Tooltip,
  tooltipClasses,
} from '@mui/material'
import {PGTypography} from '@progynyglobal/pg-ui-library'

import {PaymentFormValues} from '@progyny/pages/Budget/Reimbursement/helpers/PaymentFormModel'

import {theme} from '@root/theme'

type RecipientAndIbanFieldsProps = {
  values: Partial<PaymentFormValues>
  errors: ErrorsType
  handleOnChange: (e: React.ChangeEvent<HTMLInputElement>) => void
}

const RecipientAndIbanFields: React.FC<RecipientAndIbanFieldsProps> = ({
  values,
  errors,
  handleOnChange,
}) => {
  const {t} = useTranslation()

  return (
    <Box
      display='flex'
      mt={3}
      flexDirection={{xs: 'column', md: 'row'}}
      gap={2}
    >
      <TextField
        required
        label={t('profile_bank_details_recipients_name')}
        fullWidth
        multiline
        variant='outlined'
        margin='dense'
        placeholder={t('profile_bank_details_enter_recipients_name')}
        value={values?.accountHolderName ?? ''}
        name='accountHolderName'
        onChange={handleOnChange}
        error={errors?.accountHolderName?.hasError}
        helperText={t(errors?.accountHolderName?.message ?? '')}
      />
      <Stack width='100%'>
        <TextField
          required
          label={t('profile_bank_details_iban')}
          fullWidth
          multiline
          variant='outlined'
          margin='dense'
          placeholder={t('profile_bank_details_enter_iban')}
          value={values?.accountNumber ?? ''}
          name='accountNumber'
          onChange={handleOnChange}
          error={errors?.accountNumber?.hasError}
          helperText={t(errors?.accountNumber?.message ?? '')}
        />
        <Tooltip
          arrow
          sx={{width: 200}}
          title={t('profile_bank_details_iban_tooltip')}
          slotProps={{popper: {sx: tooltipPopperSx}}}
        >
          <Grid
            pt={1}
            width={'fit-content'}
            display={'flex'}
            alignItems={'center'}
            gap={'4px'}
            flexDirection={'row'}
          >
            <InfoOutlinedIcon
              sx={{color: theme.palette.other.brandColors.lightGray}}
            />
            <PGTypography
              variant='label'
              sx={{
                fontSize: 12,
                color: theme.palette.other.brandColors.lightGray,
              }}
            >
              {t('profile_bank_details_where_to_find_it')}
            </PGTypography>
          </Grid>
        </Tooltip>
      </Stack>
    </Box>
  )
}

export default RecipientAndIbanFields

const tooltipPopperSx = {
  [`&.${tooltipClasses.popper}[data-popper-placement*="bottom"] .${tooltipClasses.tooltip}`]:
    {
      marginTop: '0px',
    },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: 'black',
    color: 'white',
    fontSize: 12,
    lineHeight: 1.4,
    padding: '16px 24px',
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: 'black',
  },
  width: 230,
}
